import { CrmExplicits, CrmExplicitsCampaign } from '@chilipiper/api-client/src/team-scheduling'

export const CRM_EXPLICITS_PARAMS = {
  opportunityId: 'opportunityId',
  accountId: 'accountId',
  campaignId: 'campaign',
  status: 'status',
  caseId: 'caseId',
  objectId: 'objectId',
  dealId: 'dealId',
  ticketId: 'ticketId',
}

export const createCrmExplicits = (
  searchParams: URLSearchParams,
  crmExplicits?: CrmExplicits
): CrmExplicits | undefined => {
  const keys = Array.from(searchParams.keys())
  const smartParamenters = Object.keys(CRM_EXPLICITS_PARAMS).reduce((acc, key) => {
    const smartParamKey = keys.find(
      paramKey => paramKey.toLocaleLowerCase() === key.toLocaleLowerCase()
    )
    const smartParam = smartParamKey ? searchParams.get(smartParamKey) : undefined

    if (key === 'campaignId' && smartParam) {
      acc.campaign = buildCampaign(smartParam, searchParams.get('status'))
      return acc
    }

    if (smartParam) {
      const crmKey = key as keyof CrmExplicits
      acc[crmKey as Exclude<keyof CrmExplicits, 'campaign'>] = smartParam

      return acc
    }
    return acc
  }, {} as CrmExplicits)

  if (Object.keys(smartParamenters).length > 0) {
    return smartParamenters
  }

  return crmExplicits
}

const buildCampaign = (
  campaignId?: string | null,
  status?: string | null
): CrmExplicitsCampaign | undefined => {
  if (!campaignId || !status) {
    return undefined
  }

  return {
    campaignId,
    status,
  }
}
